import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
    entity: {
        id: 0,
        idModelo: 0,
        codigoModelo: "",
        modelo: "",
        descripcionModelo: "",
        codigo: "",
        nombre: "",
        descripcion: "",
        orden: 0,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listModelo: [{id: 0, codigo: "", nombre: "", descripcion: ""}],
    validationActive: {
        idModelo: false,
        codigo: false,
        nombre: false,
    },
    validationMessage: [],
  }
  
  export const areaSlice = createSlice({
    name: "area",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        var { sliceKey, name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        
        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setListModelo: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listModelo = data;
      },
      setValidationMessage: (state, action) => {
        const {sliceKey, message} = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
          state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });
  
  export const { init, setEntity, setData, setValidationMessage, activeValidations
    , setListModelo
    } = areaSlice.actions;
  export const defaultArea = {
    id: 0,
    idModelo: 0,
    codigoModelo: "",
    modelo: "",
    descripcionModelo: "",
    codigo: "",
    nombre: "",
    descripcion: "",
    orden: 0,
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
  }
  export default areaSlice.reducer;
  